<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" md="8" order="2" order-sm="1">
          <v-card flat class="pa-4">
            <v-card-title>Billing Information</v-card-title>
            <v-card-text>
              <billing-information-form
                ref="billingInformationForm"
                :numberKeyGenerate="selectedPlan.no_key_generate"
              ></billing-information-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                tile
                depressed
                large
                color="#9faebc"
                dark
                class="my-4"
                @click="submit()"
              >Check Out</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
        <v-col cols="12" md="4" order="1" order-sm="2">
          <plan-overview-card ref="planOverview" :item="selectedPlan"></plan-overview-card>
        </v-col>
      </v-row>
    </v-container>
    <v-form v-show="false" method="POST" :action="paynamics.postRedirect">
      <button type="submit" name="paymentrequest" :value="paynamics.paymentRequest" ref="redirectWebPaymentFinal">Submit</button>
    </v-form>
  </div>
</template>

<script>
import { RESELLER_EVENT_BUS } from "@/views/reseller/js/ResellerEventBus";
import Repository from "@/api/repositories";
const ResellerBillingDetailsApi = Repository.get("resellerBillingDetails");

  export default {
    name: 'ResellerCheckout',
    data: () => ({
      resellerId: null,
      plan: null,
      paynamics: {}
    }),
    components: {
      BillingInformationForm: () => import('@/components/reseller/forms/BillingInformationForm.vue'),
      PlanOverviewCard: () => import('@/components/reseller/cards/PlanOverviewCard.vue'),
    },
    computed: {
      selectedPlan: function() {
        return RESELLER_EVENT_BUS.selectedPlan;
      }
    },
    methods: {
      checkDetailsExists() {
        this.resellerId = RESELLER_EVENT_BUS.reseller.id || null;
        // this.plan = RESELLER_EVENT_BUS.selectedPlan || null;

        let valid = this.resellerId && this.selectedPlan;

        if (!valid) {
          this.$router.push(`/shop/reseller/${this.$route.params.slug}`);
          return;
        }
      },
      submit() {
        let billingInformationForm = this.$refs.billingInformationForm;
        let planOverview = this.$refs.planOverview;
        console.log({ planOverview })

        let valid = billingInformationForm.validate();

        if (valid) {
          let plan = this.selectedPlan;
          let form = billingInformationForm.form;
          form.reseller_id = this.resellerId;
          form.country = "PH";

          form.products = [
            {
              name: plan.name,
              shop_plan_id: plan.id,
              quantity: 1,
              promo_id: null,
              // discount: plan.discount,
              discount: 0,
              amount: planOverview.totalAmount
            }
          ]

          // console.log({ form });

          ResellerBillingDetailsApi
            .create(form)
            .then(response => {
              // console.log({ response });
              let {
                data : {
                  data : item
                }
              } = response;

              this.paynamics = {
                postRedirect: item.paynamics.post_redirect,
                paymentRequest: item.paynamics.payment_request
              }

              setTimeout(() => {
                this.$refs.redirectWebPaymentFinal.click();
              }, 500);
            })
            .catch(error => {
              console.log({ error });
            });
        }

        // billingInformationForm
      }
    },
    mounted() {
      this.checkDetailsExists();
    }
  }
</script>

<style lang="scss" scoped>

</style>